/*
 * @Author: cc
 * @Date: 2020-12-30 10:42:37
 * @LastEditTime: 2022-02-11 14:48:57
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\shortVideo\list.js
 * @Description: 短视频模块列表公共逻辑（待编、待审、已签发、废稿箱）
 */

'use strict';

angular.module('EditShortVideoListModule', []).controller('EditShortVideoListCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'trsHttpService',
    'editingCenterService',
    'trsspliceString',
    'storageListenerService',
    'editcenterRightsService',
    'newMediaService',
    'messagePublishService',
    'noticeWindowService',
    function (
        $scope,
        $state,
        modalDialog,
        trsHttpService,
        editingCenterService,
        trsspliceString,
        storageListenerService,
        editcenterRightsService,
        newMediaService,
        messagePublishService,
        noticeWindowService,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                showCreate: $state.params.account,
                channelId: $state.params.account,
                isEsSearch: false, // 判断是否是经过ES检索之后
                isPass: false, // 只看通过
            };
            $scope.data = {
                selectedArray: [],
                items: [],
                keyWords: '',
                account: $state.params.account,
                // isOriginal: $state.params.isOriginal,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                // AccountId: $state.params.account,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                OperTimeStart: $scope.data.fromdate,
                OperTimeEnd: $scope.data.untildate,
                searchKeyWord: $scope.data.keyWords,
                isPass: false,
            }; // 列表请求参数
            $scope.rightsParams = {
                serviceid: 'mlf_metadataright',
                // AccountId: $state.params.account,
            }; // 权限请求参数
            $scope.statusOptions = [
                {
                    name: '全部状态',
                    value: '',
                },
                {
                    name: '审核中',
                    value: 12,
                },
                {
                    name: '审核成功',
                    value: 14,
                },
                {
                    name: '签发失败',
                    value: 13,
                },
            ];
            $scope.compareStatus = {
                '已签发': 'signSuccess',
                '审核完成': 'signSuccess',
                '签发中': 'signing',
                '审核中': 'signing',
                '签发失败': 'signError'
            };
            $scope.selectedStatusItem = $scope.statusOptions[0];
            $scope.status = angular.extend($scope.status, $scope.trenchStatus);
            $scope.data = angular.extend($scope.data, $scope.trenchData);
            $scope.params = angular.extend($scope.params, $scope.trenchParams);
            $scope.rightsParams = angular.extend($scope.rightsParams, $scope.trenchRightsParams);
            $scope.status.mediaType = $scope.data.trenchConst.mediaType; // es检索等原来指令需要使用的是这个mediaType
            $scope.data.trench = $scope.data.trenchConst.trench; // 各种稿件操作需要的标识，兼容原来逻辑
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            listenStorage();
            refreshList();
        }

        /**
         * [requestData description]  用于记忆功能，在app.js中$transitions.onSuccess方法中调用
         * @return  {[type]}  [return description]
         */
        $scope.requestData = function () {
            if ($scope.data.keyWords) $scope.data.keyWords = ''; // 切换账号时关清除检索词
            if ($scope.status.isEsSearch) $scope.status.isEsSearch = false; // 切换账号时关闭es状态
            requestData();
            initBtnRights(); // 切换账号时也需要请求下权限
        };

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function (event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    }
                    // 暂时的其他情况是boolean
                    else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {};
            if ($scope.status.isEsSearch) {
                params = $scope.esparams;
                params.searchParams.PAGEINDEX = $scope.page.CURRPAGE;
            } else {
                params = $scope.params;
                params[$scope.data.trenchConst.accountKey] = $state.params.account; // 因为切换账号没有刷新页面，所以需要手动指定一下
                params.CurrPage = $scope.page.CURRPAGE;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
                if ($scope.data.items.length) {
                    editingCenterService.queryVerifyDoc($scope.data.items);
                }
                newMediaService.getReviseInfo($scope.data.items);
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenDraftChange(() => {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('editCommonDraftedit');
            }, $scope);
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return  {[type]}  [return description]
         */
        function initBtnRights() {
            $scope.rightsParams[$scope.data.trenchConst.accountKey] = $state.params.account; // 因为切换账号没有刷新页面，所以需要手动指定一下
            editcenterRightsService.initListBtn($scope.rightsParams).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }


        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [draftlist description]发稿单
         * @return {[type]} [description]
         */
        $scope.draftlist = function () {
            const params = {
                0: $scope.data.trenchConst.draftListDB,
                1: $scope.data.trenchConst.draftListDS
            }
            newMediaService.draftlist($scope, params[$scope.trenchStatus.status_model], $scope.data.trenchConst.draftListQuery);
        };


        /**
         * [trial description]送审操作
         * @return {[type]} [description]
         */
        $scope.trial = function () {
            newMediaService.trial($scope, $scope.data.trenchConst.trial);
        };

        /**
         * [withdraw description] 撤稿操作
         * @return  {[type]}  [return description]
         */
        $scope.withdraw = function () {
            $scope.loadingPromise = newMediaService.rejection($scope, $scope.data.trenchConst.rejection);
        };


        /**
         * [sign description]稿件签发
         * @return {[type]} [description]
         */
        $scope.sign = function () {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '每次最多签发一个稿件', 'warning', 'confirm');
                return;
            }
            $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.data.trenchConst.mediaType).then(function () {
                $scope.loadingPromise = newMediaService.sign($scope, $scope.data.trenchConst.sign);
            });
        };

        /**
         * [abandonDraft description]废稿函数
         * @param  {[obj]} item [description]稿件信息
         * @return {[type]}      [description]
         */
        $scope.delete = function () {
            newMediaService.delete($scope, $scope.data.trenchConst.delete);
        };

        /**
         * [fullTextSearch description]搜索
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function (ev) {
            $scope.status.isESSearch = true;
            if ((angular.isDefined(ev) && ev.keyCode * 1 === 13) || !ev) {
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [queryByDropdown description] 按时间检索
         * @param   {[type]}  type  [type description]
         * @param   {[type]}  val  [time description]
         * @return  {[type]}        [return description]
         */
        $scope.queryByDropdown = function (type, val) {
            if (type === 'DocType') {
                $scope.params.docstatus = val;
            }
            $scope.page.CURRPAGE = 1;
            $scope.params.OperTimeStart = $scope.data.fromdate;
            $scope.params.OperTimeEnd = $scope.data.untildate;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [pageChanged description] 翻页
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function () {
            requestData();
        };

        /**
         * [jumpToPage description] 跳页
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function () {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [revise description] 修订方法
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            var params = {
                DocIds: trsspliceString.spliceString($scope.data.selectedArray, $scope.data.trenchConst.draftIdKey, ','),
                MediaType: $scope.data.trenchConst.mediaType,
            };
            newMediaService.revise($scope, params);
        };

        /**
         * [processRecord description] 获取企鹅号流程记录
         * @param   {[type]}  item  [item description] 选中的企鹅号稿件
         * @return  {[type]}        [return description]
         */
        $scope.processRecord = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function () {
            $scope.status.isEsSearch = false;
            editingCenterService.distribution($scope.data.selectedArray, $scope.data.trenchConst.mediaType, $scope.data.selectedArray[0].DOCTYPEID, $scope.distributionMethodName, function () {
                $scope.data.selectedArray = [];
                requestData();
            });
            // var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            // if (temp.length < 1) {

            // } else {
            //     modalDialog.alertType('', '多元分发仅支持的稿件类型为视频', 'warning', 'confirm');
            // }
        };

        /**
         * [isOnlyMine description] 只看我的/只看通过
         *
         * @param {[type]} key   [key description] 代表是改变通过还是我的的状态
         *
         * @return {[type]}   [return description] null
         */
        $scope.isOnlyMine = function(key) {
            $scope.page.CURRPAGE = 1;
            $scope.params[key] = !$scope.params[key];
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };
    },
]);
